import React, { useRef, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import _ from 'lodash';
import moment from 'moment';
import * as taxApi from '../../../lib/api/taxbill';
import { useFormik, FormikProvider } from 'formik';

//mui
import { Box, Button, Divider, Typography } from '@mui/material';

import PurchaseBillFormList from '../../../components/projectmng/bill_mng/PurchaseBillFormList';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  listProjectBuyTaxbills,
  listProjectInitBuyTaxbills,
} from '../../../modules/projectModule/issue-taxbills';
import AutoBillForm from '../../../components/projectmng/bill_mng/AutoBillForm';

//-----------------------------------------------------
//-----------------------------------------------------

const PurchaseBillFormContainer = ({ project }) => {
  const dispatch = useDispatch();
  const arrayHelperRef = useRef();
  const { enqueueSnackbar } = useSnackbar();

  const { initBuyTaxbills } = useSelector(({ projectModule }) => ({
    initBuyTaxbills: projectModule.issueTaxbills.initBuyTaxbills,
  }));

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  const onCancle = () => {
    setVisible(false);
  };

  // 자동 배치
  const [showForm, setShowForm] = useState(false);

  const [initialValues, setInitialValues] = useState({ purchaseBills: [] });

  useEffect(() => {
    if (project) {
      //getInitTaxbills(project.prjUuid);
      dispatch(listProjectInitBuyTaxbills(project.prjUuid));
    }
  }, [project]);

  useEffect(() => {
    if (initBuyTaxbills) {
      setInitialValues({ purchaseBills: initBuyTaxbills });
    }
  }, [initBuyTaxbills]);

  // const getInitTaxbills = async (id) => {
  //   try {
  //     const res = await taxApi.getInitTaxbillByPrj(id, 'B');
  //     if (res.data.list) {
  //       const purchaseBills = res.data.list.map((item) => ({
  //         ...item,
  //         buyDiv: 1,
  //       }));
  //       const changeInit = { purchaseBills };
  //       setInitialValues(changeInit);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  let validationSchema = yup.object({
    purchaseBills: yup.array().of(
      yup.object().shape({
        reqCompDt: yup.string('').required('매입일자를 입력하세요'),
        invTxt: yup.string('').required('매입내용을 입력하세요'),
        invAmt: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입금액을 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        invVat: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('부가세를 입력하세요')
          .min(0, '최소 0 이상을 입력하세요'),
        prodCompDt: yup.string('').required('지급예정일자를 입력하세요'),
        buyDiv: yup
          .number('숫자만 가능합니다(소수점은 불가)')
          .required('매입횟수 입력하세요')
          .min(1, '최소 1 이상을 입력하세요')
          .max(24, '최대 24 이하만 가능합니다'),
      }),
    ),
  });

  const makeData = (values) => {
    const data = [];
    _.forEach(values, (value) => {
      if (Number(value?.invAmt) > 0) {
        value.reqCompDt = moment(value.reqCompDt).format('YYYY-MM-DD');
        value.prodCompDt = moment(value.prodCompDt).format('YYYY-MM-DD');
        data.push(value);
      }
    });
    return data;
  };
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const valid = checkValidation();
      if (!valid) {
        setVisible(true);
        setSubmitting(false);
        return;
      }

      setSubmitting(true);

      setTimeout(() => {
        onSave(values);

        formik.resetForm();
      }, 1000);
    },
  });

  const onSave = async (values) => {
    const saveData = {
      type: 'B',
      data: makeData(values.purchaseBills),
    };

    try {
      const res = await taxApi.addIssuedTaxbill(project.prjUuid, saveData);

      if (res?.data?.result === 'success') {
        dispatch(listProjectBuyTaxbills(project?.prjUuid));
        dispatch(listProjectInitBuyTaxbills(project?.prjUuid));
        enqueueSnackbar('매입계산서 저장 성공', {
          variant: 'success',
        });
      }
      //redux
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const checkValidation = () => {
    let valid = true;
    //원가산출 체크
    // eslint-disable-next-line array-callback-return
    const findItem = formik.values.purchaseBills.find((item) => {
      //해외거래가 아닐때만 체크함.
      if (item?.osTran !== 'Y') {
        const perVat = (Number(item?.invVat) / Number(item?.invAmt)) * 100;

        //부가세가 9% 미만 12% 초과
        if (perVat < 9 || perVat > 12) {
          setMessage(
            '부가세가 매입금액의 9% 미만 또는 12% 초과인 항목이 있습니다.등록폼을 확인하십시오',
          );
          return item;
        }

        if (
          Number(item?.billSumTotal) <
          Number(item?.billIssuedTotal) + Number(item.invAmt)
        ) {
          setMessage(
            '기매입금액과 매입금액의 합계가 총매입금액을 초과하는 항목이 있습니다. 등록폼을 확인하십시오.',
          );
          return item;
        }
      }
    });

    valid = findItem ? false : true;

    return valid;
  };

  const handleAutoBatch = (data) => {
    const autoData = initBuyTaxbills.map((item) => {
      const alotal = parseInt(item?.billSumTotal);
      const itotal = parseInt(item?.billIssuedTotal);
      const total = alotal - itotal;
      const div = parseInt(data?.buyDiv);

      const invAmt = Math.round(total / div);
      const invVat = item?.osTran === 'Y' ? 0 : invAmt / 10;
      return {
        ...item,
        reqCompDt: data?.reqCompDt,
        invTxt:
          (data?.invTxtBefore ? data?.invTxtBefore + ' ' : '') +
          item?.invTxt +
          (data?.invTxtAfter ? data?.invTxtAfter + ' ' : ''),
        prodCompDt: data?.prodCompDt,
        invAmt: invAmt,
        invVat: invVat,
        buyDiv: data?.buyDiv,
      };
    });
    // console.log(autoData);
    formik.setFieldValue('purchaseBills', autoData);
  };

  if (initBuyTaxbills && initBuyTaxbills.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="subtitle2">
          발행할 매입 계산서 내역이 없습니다.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Box sx={{ my: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="outlined"
            color="warning"
            onClick={() => setShowForm(true)}
          >
            자동배치
          </Button>
        </Box>
        {showForm && (
          <AutoBillForm
            onAutoBtn={handleAutoBatch}
            onCancle={() => setShowForm(false)}
          />
        )}
      </Box>
      <Divider sx={{ my: 1 }} />
      <FormikProvider value={formik}>
        <PurchaseBillFormList formik={formik} ArrayHelperRef={arrayHelperRef} />
      </FormikProvider>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Button type="submit" variant="outlined" disabled={formik.isSubmitting}>
          등록
        </Button>
      </Box>
      <AskDialog
        visible={visible}
        title="등록 오류"
        description={message}
        onCancle={onCancle}
        onConfirm={onCancle}
      />
    </Box>
  );
};

export default PurchaseBillFormContainer;
